import { createContext, useContext } from 'react';

/**
 * Provided by a section view so any chip deep in a table can open its source.
 *   openSource({ fileId, fileName, page, quote, label, value, kind, sequence, index })
 * ``sequence`` (all cites of the section, in display order) lets the source panel
 * step to the previous / next citation with J / K.
 */
const CitationContext = createContext({
  openSource: null,
  defaultFileId: null,
  defaultFileName: null,
});

export const useCitations = () => useContext(CitationContext);

export default CitationContext;
